var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.2416 37.2804V37.594L40.5239 37.7305L55.2205 44.8378L53.5073 48.5055L36.2646 40.167V12.7939H40.2416V37.2804Z",
    fill: "#FF8D3D",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 38C0.5 17.2894 17.2894 0.5 38 0.5C58.7106 0.5 75.5 17.2894 75.5 38C75.5 58.7106 58.7106 75.5 38 75.5C17.2894 75.5 0.5 58.7106 0.5 38ZM4.56667 38C4.56667 56.4647 19.5353 71.4333 38 71.4333C56.4647 71.4333 71.4333 56.4647 71.4333 38C71.4333 19.5353 56.4647 4.56667 38 4.56667C19.5353 4.56667 4.56667 19.5353 4.56667 38Z",
    fill: "#21014C",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7642 65.5068C18.7771 63.4329 20.8219 61.8921 23.1312 60.3525",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6836 67.782C20.3835 66.8861 25.8962 61.0374 26.9602 60.5054",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4268 72.2524C35.1267 71.3565 38.8202 67.3269 39.8842 66.7949",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2041 68.8997C22.9691 67.8478 28.2203 63.3196 28.8743 62.2295",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0649 72.2524C38.83 71.2005 42.8683 67.885 43.5224 66.7949",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9326 71.4383C26.7912 70.266 30.9566 66.6271 32.5124 65.0713",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7939 72.556C42.6525 71.3837 46.818 67.7447 48.3737 66.189",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5293 63.2719C16.3237 61.5304 18.3958 60.0268 19.9867 58.1177",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4795 60.6182C12.4498 59.9713 17.4636 56.9851 18.1497 56.0703",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94092 58.877C9.98277 58.0323 10.7714 56.9387 12.0234 56.3589C12.565 56.108 15.4891 54.0722 15.9143 53.647",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82324 54.5193C9.67022 53.6462 11.2968 52.4154 13.0533 51.4116",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.70557 51.7534C8.11095 50.9606 9.49045 49.6881 11.026 49.1763",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7422 72.025C30.0855 70.8648 31.3616 69.6114 32.7553 68.513C33.5775 67.865 34.5255 67.3492 35.4124 66.7949",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7207 72.025C47.064 70.8648 48.3401 69.6114 49.7338 68.513C50.556 67.865 51.504 67.3492 52.3909 66.7949",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.645 14.9907C62.9288 15.9785 60.4167 16.4727 57.667 16.8503",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9682 18.6279C65.2521 19.6157 62.7399 20.1099 59.9903 20.4875",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9983 11.8901C61.9776 12.3908 54.4654 15.2481 53.2759 15.2625",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7185 9.96992C58.5712 10.5826 51.8705 12.3658 50.8063 13.0612",
    stroke: "#21014C",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M56.095 7.77691C53.9112 8.02079 48.5754 9.47752 46.4967 10.1985",
    stroke: "#21014C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.69e54a35a66c21ae618c5040c554795b.svg";
export { ForwardRef as ReactComponent };